import Bash_Home from './Bash_Home';
import Bash_Intro from './Bash_Intro';
import Bash_Get_Started from './Bash_Get_Started';
import Bash_Commands from './Bash_Commands';
import Bash_Ls from './Bash_Ls';
import Bash_Cd from './Bash_Cd';
import Bash_Pwd from './Bash_Pwd';
import Bash_Echo from './Bash_Echo';
import Bash_Cat from './Bash_Cat';
import Bash_Cp from './Bash_Cp';
import Bash_Mv from './Bash_Mv';
import Bash_Rm from './Bash_Rm';
import Bash_Touch from './Bash_Touch';
import Bash_Mkdir from './Bash_Mkdir';
import Bash_Man from './Bash_Man';
import Bash_Alias from './Bash_Alias';
import Bash_Grep from './Bash_Grep';
import Bash_Awk from './Bash_Awk';
import Bash_Sed from './Bash_Sed';
import Bash_Cut from './Bash_Cut';
import Bash_Sort from './Bash_Sort';
import Bash_Tail from './Bash_Tail';
import Bash_Head from './Bash_Head';
import Bash_Ps from './Bash_Ps';
import Bash_Top from './Bash_Top';
import Bash_Df from './Bash_Df';
import Bash_Du from './Bash_Du';
import Bash_Free from './Bash_Free';
import Bash_Kill from './Bash_Kill';
import Bash_Uptime from './Bash_Uptime';
import Bash_Ping from './Bash_Ping';
import Bash_Curl from './Bash_Curl';
import Bash_Wget from './Bash_Wget';
import Bash_Ssh from './Bash_Ssh';
import Bash_Scp from './Bash_Scp';
import Bash_Rsync from './Bash_Rsync';
import Bash_Zip from './Bash_Zip';
import Bash_Unzip from './Bash_Unzip';
import Bash_Tar from './Bash_Tar';
import Bash_Ownership from './Bash_Ownership';
import Bash_Chmod from './Bash_Chmod';
import Bash_Chown from './Bash_Chown';
import Bash_Chgrp from './Bash_Chgrp';
import Bash_Syntax from './Bash_Syntax';
import Bash_Script from './Bash_Script';
import Bash_Variables from './Bash_Variables';
import Bash_Data_Types from './Bash_Data_Types';
import Bash_Operators from './Bash_Operators';
import Bash_If_Else from './Bash_If_Else';
import Bash_Loops from './Bash_Loops';
import Bash_Functions from './Bash_Functions';
import Bash_Arrays from './Bash_Arrays';
import Bash_Cron from './Bash_Cron';
import Bash_Exercises from './Bash_Exercises';
import Bash_Quiz from './Bash_Quiz';
import Bash_Certificate from './Bash_Certificate';

const AllBashComponents = {
  "Bash_Home": Bash_Home,
  "Bash_Intro": Bash_Intro,
  "Bash_Get_Started": Bash_Get_Started,
  "Bash_Commands": Bash_Commands,
  "Bash_Ls": Bash_Ls,
  "Bash_Cd": Bash_Cd,
  "Bash_Pwd": Bash_Pwd,
  "Bash_Echo": Bash_Echo,
  "Bash_Cat": Bash_Cat,
  "Bash_Cp": Bash_Cp,
  "Bash_Mv": Bash_Mv,
  "Bash_Rm": Bash_Rm,
  "Bash_Touch": Bash_Touch,
  "Bash_Mkdir": Bash_Mkdir,
  "Bash_Man": Bash_Man,
  "Bash_Alias": Bash_Alias,
  "Bash_Grep": Bash_Grep,
  "Bash_Awk": Bash_Awk,
  "Bash_Sed": Bash_Sed,
  "Bash_Cut": Bash_Cut,
  "Bash_Sort": Bash_Sort,
  "Bash_Tail": Bash_Tail,
  "Bash_Head": Bash_Head,
  "Bash_Ps": Bash_Ps,
  "Bash_Top": Bash_Top,
  "Bash_Df": Bash_Df,
  "Bash_Du": Bash_Du,
  "Bash_Free": Bash_Free,
  "Bash_Kill": Bash_Kill,
  "Bash_Uptime": Bash_Uptime,
  "Bash_Ping": Bash_Ping,
  "Bash_Curl": Bash_Curl,
  "Bash_Wget": Bash_Wget,
  "Bash_Ssh": Bash_Ssh,
  "Bash_Scp": Bash_Scp,
  "Bash_Rsync": Bash_Rsync,
  "Bash_Zip": Bash_Zip,
  "Bash_Unzip": Bash_Unzip,
  "Bash_Tar": Bash_Tar,
  "Bash_Ownership": Bash_Ownership,
  "Bash_Chmod": Bash_Chmod,
  "Bash_Chown": Bash_Chown,
  "Bash_Chgrp": Bash_Chgrp,
  "Bash_Syntax": Bash_Syntax,
  "Bash_Script": Bash_Script,
  "Bash_Variables": Bash_Variables,
  "Bash_Data_Types": Bash_Data_Types,
  "Bash_Operators": Bash_Operators,
  "Bash_If_Else": Bash_If_Else,
  "Bash_Loops": Bash_Loops,
  "Bash_Functions": Bash_Functions,
  "Bash_Arrays": Bash_Arrays,
  "Bash_Cron": Bash_Cron,
  "Bash_Exercises": Bash_Exercises,
  "Bash_Quiz": Bash_Quiz,
  "Bash_Certificate": Bash_Certificate,
};

export default AllBashComponents;
